import React, { useState } from 'react';

import { BottomDrawer } from 'components/core';
import { ModalWrapper } from 'shared/modals/v2-wrapper';
import { DesktopOnly, MobileOnly } from 'shared/components';
import useErnie from 'shared/hooks/use-ernie';
import { withModalControlsHook, ModalComponentProps } from 'components/modals/with-modal-controls-hook';
import useDutchiePayEnrollment from 'hooks/use-dutchiePay-enrollment';
import { useDutchiePay } from 'src/payments/hooks';
import { useOpenDutchiePay } from 'src/payments/hooks/use-open-dutchie-pay/use-open-dutchie-pay';
import { editBankAccount } from 'src/payments/constants';

import { AddFundsModalContent } from './add-funds-modal';
import { DrawerContent, StyledModalContainer } from './add-funds-modal.styles';
import { loadFunds } from './load-funds';

const AddFundsModalControllerInner = ({ onClose, containerProps }: ModalComponentProps): JSX.Element | null => {
  const { activeBankAccount } = useDutchiePay();
  const DutchiePayEnrollment = useDutchiePayEnrollment();
  const { openDutchiePay } = useOpenDutchiePay({ step: editBankAccount });
  const showErnie = useErnie();
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!activeBankAccount) {
    return null;
  }

  const handleChangeBank = (): void => {
    openDutchiePay(editBankAccount);
    DutchiePayEnrollment.editBankAccount();
  };

  const handleSubmit = (amountCents: number): void => {
    setIsSubmitting(true);
    loadFunds(amountCents)
      .then(() => onClose())
      .catch(() => {
        setIsSubmitting(false);
        showErnie('Something went wrong adding funds to your wallet. Please try again.', 'error');
      });
  };

  // loadedTodayCents is mocked at 0 until live wallet activity data is wired in.
  const content = (
    <AddFundsModalContent
      bankAccount={activeBankAccount}
      isSubmitting={isSubmitting}
      onClose={onClose}
      onChangeBank={handleChangeBank}
      onSubmit={handleSubmit}
      loadedTodayCents={0}
    />
  );

  return (
    <>
      <DesktopOnly mediaQuery='sm'>
        <ModalWrapper open zIndex={1600} onClose={isSubmitting ? undefined : onClose}>
          <StyledModalContainer width='460px' padding='32px' {...containerProps}>
            {content}
          </StyledModalContainer>
        </ModalWrapper>
      </DesktopOnly>
      <MobileOnly mediaQuery='xs'>
        <BottomDrawer
          open
          hideExitIcon
          onClose={isSubmitting ? undefined : onClose}
          shouldCalculateIframeBottom
          {...containerProps}
        >
          <DrawerContent>{content}</DrawerContent>
        </BottomDrawer>
      </MobileOnly>
    </>
  );
};

const [AddFundsModalController, useAddFundsModal] = withModalControlsHook(AddFundsModalControllerInner);

export { AddFundsModalController, useAddFundsModal, AddFundsModalControllerInner };
